import { cn } from '@/lib/cn'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'

interface BloodStockGridProps {
  stocks: Array<{ group: string; quantity: number; status: 'normal' | 'alert' | 'critical' }>
  onUpdate: (group: string, quantity: number) => void
}

export function BloodStockGrid({ stocks, onUpdate }: BloodStockGridProps) {
  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3">
      {stocks.map((stock) => {
        const statusColors = {
          normal: 'bg-success-50 border-success-200 text-success-700',
          alert: 'bg-warning-50 border-warning-200 text-warning-700',
          critical: 'bg-error-50 border-error-200 text-error-700',
        }
        return (
          <div
            key={stock.group}
            className={cn(
              'rounded-lg border p-2 sm:p-3 flex flex-col items-center gap-1.5 transition-colors',
              statusColors[stock.status]
            )}
          >
            <span className="text-xs font-bold">{stock.group}</span>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => onUpdate(stock.group, Math.max(0, stock.quantity - 1))}
                className="w-6 h-6 rounded border border-current/20 flex items-center justify-center hover:bg-white/50 transition-colors"
              >
                <MinusIcon className="w-3 h-3" />
              </button>
              <span className="w-6 text-center text-base font-bold tabular-nums">{stock.quantity}</span>
              <button
                type="button"
                onClick={() => onUpdate(stock.group, stock.quantity + 1)}
                className="w-6 h-6 rounded border border-current/20 flex items-center justify-center hover:bg-white/50 transition-colors"
              >
                <PlusIcon className="w-3 h-3" />
              </button>
            </div>
            <span className="text-[10px] opacity-70">poches</span>
          </div>
        )
      })}
    </div>
  )
}
